var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c("el-rate", {
        ref: "fieldEditor",
        attrs: {
          disabled: _vm.field.options.disabled,
          max: Number(_vm.field.options.max),
          "low-threshold": _vm.field.options.lowThreshold,
          "high-threshold": _vm.field.options.highThreshold,
          "allow-half": _vm.field.options.allowHalf,
          "show-text": _vm.field.options.showText,
          "show-score": _vm.field.options.showScore,
        },
        on: { change: _vm.handleChangeEvent },
        model: {
          value: _vm.fieldModel,
          callback: function ($$v) {
            _vm.fieldModel = $$v
          },
          expression: "fieldModel",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }